module.exports = __webpack_public_path__ + "img/acc.28d8436e.jpg";